import { renderTestStatusBadge } from "helpers/RequestTestsHelper";

const TestStatusBadge = ({ statusId }) => {
  if (!statusId) return null;

  return renderTestStatusBadge(statusId);
};

export default TestStatusBadge;
